// extracted by mini-css-extract-plugin
module.exports = {"loading":"_28tnm06BkLYYy5jOtMdtUk","CCBEvents":"_2hdkXmrwggognepO0C3Aut"};